import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {MARKETPLACES_ROUTES, USER_ROLES} from "@constants"
import MarketplacesGeneralPage from "./General";
import MarketplacesSellerDetailsPage from "./SellerDetails";
import MarketplacesSellerDeepDivePage from "./SellerDeepDive";
import LostBuyBoxPage from "./LostBuyBoxDetails";
import MarketplacesLostBuyBoxOverviewPage from "./LostBuyBoxOverview";
import MarketplacesOffersDetailsPage from "./OffersDetails";


export const MarketplacesRoutes = {
    path: MARKETPLACES_ROUTES.PATH,
    title: MARKETPLACES_ROUTES.TITLE,
    accessKey: MARKETPLACES_ROUTES.ACCESS_KEY,
    icon: 'cart-circle-check',
    description: "Identifying key players offering your products and understanding pricing dynamics vs competition",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={MARKETPLACES_ROUTES.OVERVIEW_PATH} replace />,  index: true
    }, {
        title: 'Marketplaces Overview',
        path: MARKETPLACES_ROUTES.OVERVIEW_PATH,
        dashboardKey: MARKETPLACES_ROUTES.OVERVIEW_ID,
        element: <MarketplacesGeneralPage />
    }, {
        path: 'divider'
    }, {
        title: 'Marketplaces Seller Details',
        path: MARKETPLACES_ROUTES.SELLER_DETAILS_PATH,
        dashboardKey: MARKETPLACES_ROUTES.SELLER_DETAILS_ID,
        element: <MarketplacesSellerDetailsPage />
    }, {
        title: 'Marketplaces Seller Deep Dive',
        path: MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_PATH,
        dashboardKey: MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_ID,
        element: <MarketplacesSellerDeepDivePage />
    }, {
        title: 'Marketplaces Offers Details',
        path: MARKETPLACES_ROUTES.OFFERS_DETAILS_PATH,
        dashboardKey: MARKETPLACES_ROUTES.OFFERS_DETAILS_ID,
        element: <MarketplacesOffersDetailsPage />
    }, {
        title: 'Marketplaces Lost Buy Box Daily Details',
        path: MARKETPLACES_ROUTES.LBBDETAILS_PATH,
        dashboardKey: MARKETPLACES_ROUTES.LBBDETAILS_ID,
        access: USER_ROLES.STANDARD,
        element: <LostBuyBoxPage />
    }, {
        title: 'Marketplaces Lost Buy Box Aggregated Overview',
        path: MARKETPLACES_ROUTES.LBBOVERVIEW_PATH,
        dashboardKey: MARKETPLACES_ROUTES.LBBOVERVIEW_ID,
        access: USER_ROLES.STANDARD,
        element: <MarketplacesLostBuyBoxOverviewPage />
    }]
}